// Diamond shop. Diamonds buy convenience, boosts and looks; never fight speed
// or anything that can reach the market. The paid effects allowed, all
// account-bound:
//   - XP: VIP, the season pass (sold on its own page, shared/pass.ts), Trainer XP and Creature XP boosts (shared/boosts.ts),
//     the XP Charm, and the Late Joiner boost (×10 XP up to the server median,
//     shared/latejoiner.ts; no XP lost to a knockout while it runs).
//   - Coins: the Loot boost (more kill coins; never any drop: no ascension
//     or star items, shards, keys, tokens, eggs, tablets or relics).
//   - Odds: never. The Aura and Catch Charms are won only in ranked seasons
//     (owner's call, 2026-10-15); the Aura Charm offer here stays off sale.
//   - Looks: outfits, name colors, Name Tags.
// Only the Aura Charm marks what is caught under it (CreatureDTO.boosted); the
// XP, Loot and Late Joiner boosts mark nothing (owner's call, 2026-10-14).
import { NAME_TAG, NAME_TAG_PRICE } from './nametags.ts';
import { CONFIG } from './config.ts';
import { AURA_CHARM } from './auracharm.ts';

export interface DiamondOffer { id: string; name: string; desc: string; price: number }

/** The Aura Charm's offer, kept for when Cole decides how it is given; listed only while CONFIG.auraCharm.forSale. */
export const AURA_CHARM_OFFER: DiamondOffer = { id: AURA_CHARM, name: `Aura Charm, ${CONFIG.auraCharm.hours} hours`, desc: `Aura odds ×${CONFIG.auraCharm.oddsMult} on your hunt catches: 1 in ${(CONFIG.auraCatchOneIn / CONFIG.auraCharm.oddsMult).toLocaleString('en-US')} catches. Buying again adds time. Stays on your account.`, price: CONFIG.auraCharm.price };

export const DIAMOND_SHOP: DiamondOffer[] = [
  { id: 'vip30', name: 'VIP, 30 days', desc: '+25% XP from kills, plus auto-restock and auto-move in Automation, for 30 days.', price: 30 },
  ...(CONFIG.auraCharm.forSale ? [AURA_CHARM_OFFER] : []),
  { id: 'xp-charm', name: 'XP Charm', desc: 'One creature holding it gets 5% of the lead\'s kill XP, even in storage. Stays on your account.', price: 15 },
  { id: NAME_TAG, name: 'Name Tag', desc: 'Give one of your creatures a nickname on its page. Looks only; it comes off if the creature is sold. Stays on your account.', price: NAME_TAG_PRICE },
  { id: 'color-frost', name: 'Name color: Frost', desc: 'Your name shows in frost blue in chat and broadcasts.', price: 5 },
  { id: 'color-ember', name: 'Name color: Ember', desc: 'Your name shows in ember orange.', price: 5 },
  { id: 'color-gold', name: 'Name color: Gold', desc: 'Your name shows in gold.', price: 15 },
];

export const NAME_COLORS: Record<string, string> = { 'color-frost': '#7fc8e8', 'color-ember': '#f08a2c', 'color-gold': '#f0c45a' };
